module.exports = __webpack_public_path__ + "static/media/hall-P12.429c5162.svg";